import { AdminCarResponse, AdminCar, AdminCarTransmissionEnum, AdminCarExtrasTypeEnum } from '@mol-limo-reg/admin-api';
import { Car } from './manage-cars.interfaces';

/**
 * Maps API car response to local Car interface
 * @param apiCar - Car data from API
 * @returns Local Car object for display
 */
export function mapAdminCarResponseToCar(apiCar: AdminCarResponse): Car {
  return {
    modelId: apiCar.id || '',
    vulogModelid: apiCar.vulogModelid,
    make: apiCar.make || '',
    model: apiCar.model || '',
    name: apiCar.name || '',
    category: apiCar.category || '',
    transmission: apiCar.transmission,
    numberOfSeats: apiCar.numberOfSeats,
    largeLuggageCapacity: apiCar.largeLuggageCapacity,
    smallLuggageCapacity: apiCar.smallLuggageCapacity,

    imageAssetUrl: apiCar.imageAssetUrl?.mediumImageUrl || apiCar.imageAssetUrl?.smallImageUrl || apiCar.imageAssetUrl?.largeImageUrl,

    extras: (apiCar.extras || []).map((extra) => ({
      nameHu: extra.hungarianName || '',
      nameEn: extra.englishName || '',
      enabled: extra.selected ?? true,
      isCustom: extra.type === 'CUSTOM',
    })),
  };
}

/**
 * Maps local Car to API AdminCar format for updates
 * @param car - Local Car object
 * @returns AdminCar object for API request
 */
export function mapCarToAdminCar(car: Car): AdminCar {
  return {
    id: car.modelId,
    vulogModelid: car.vulogModelid,
    make: car.make,
    model: car.model,
    name: car.name,
    category: car.category,
    transmission: car.transmission as AdminCarTransmissionEnum | undefined,
    numberOfSeats: car.numberOfSeats,
    largeLuggageCapacity: car.largeLuggageCapacity,
    smallLuggageCapacity: car.smallLuggageCapacity,
    extras: car.extras.map((extra) => ({
      hungarianName: extra.nameHu,
      englishName: extra.nameEn,
      type: (extra.isCustom ? AdminCarExtrasTypeEnum.CUSTOM : AdminCarExtrasTypeEnum.MANDATORY) as AdminCarExtrasTypeEnum,
      selected: extra.enabled,
    })),
  };
}
